module.exports = __webpack_public_path__ + "img/ty.742db0d8.png";